<script setup lang="ts">
import { computed } from "vue";
import FilterValueDTO = App.Data.Explorer.Filter.FilterValueDTO;

const days = [
	"Monday",
	"Tuesday",
	"Wednesday",
	"Thursday",
	"Friday",
	"Saturday",
	"Sunday",
] as const;

const model = defineModel<FilterValueDTO[]>({ default: [] });
const selectedDays = computed({
	get: () => {
		return model.value.map((item) => item.id as number);
	},
	set: (selectedIds: number[]) => {
		const selected = selectedIds.map((id) => ({
			id,
			level: null,
			selection_depth: null,
			model: null,
			label: days[id - 1],
		}));

		model.value = selected;
	},
});
</script>

<template>
	<div class="day-picker pa-3">
		<div class="d-flex align-center mb-1">
			<v-icon
				icon="fa-regular fa-calendar"
				color="primary"
				class="mr-2"
				size="small"
			/>
			<span class="text-subtitle-2 font-weight-medium">Day of Week</span>
		</div>

		<v-btn-toggle
			v-model="selectedDays"
			color="primary"
			multiple
			density="comfortable"
			class="day-selector rounded-lg w-100 mt-1"
			variant="outlined"
		>
			<v-btn
				v-for="(day, index) in days"
				:key="index"
				:value="index + 1"
				class="flex-grow-1"
				min-width="40"
			>
				{{ day.substring(0, 3) }}
			</v-btn>
		</v-btn-toggle>
	</div>
</template>

<style scoped lang="scss">
.day-picker {
	border-color: rgba(var(--v-theme-on-surface), 0.12);
}

.day-selector {
	box-shadow: 0 0 0 1px rgba(var(--v-theme-on-surface), 0.12);

	:deep(.v-btn) {
		border-radius: 0;
		border: none !important;
		font-size: 0.8125rem;
		letter-spacing: 0.0125em;
		border-right: 1px solid rgba(var(--v-theme-on-surface), 0.12) !important;

		&:last-child {
			border-right: none !important;
		}
	}
}
</style>
